<template>
  <div class="i18n-select">
    <q-select
      v-model="value"
      @input="doChangeLanguage"
      placeholder
      :options="languages"
      outlined
      autofocus
      map-options
      fill-input
      dense
      options-dense
      emit-value
      :behavior="
        $q.platform.is.ios === true ? 'menu' : 'menu'
      "
    >
      <!-- :behavior="$q.platform.is.ios === true ? 'dialog' : 'menu'" -->

      <template v-slot:option="scope">
        <q-item
          v-bind="scope.itemProps"
          v-on="scope.itemEvents"
        >
          <q-item-section avatar>
            <img
              :src="scope.opt.icon"
              style="width:25px ;"
            />
          </q-item-section>

          <q-item-section>
            {{ scope.opt.label }}
          </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
// import { I18nUtil } from '@/shared/i18n/i18n-util';
import i18n from '@/vueI18n'
import { getLanguages, getLanguageCode, setLanguageCode } from '@/i18n';
import Quasar from 'quasar'

export default {
  name: 'app-i18n-select',

  data() {
    return {
      value: getLanguageCode(),
      objValues: {},
    };
  },

  computed: {
    // languages() {
    //   return getLanguages();
    // },

    languages() {
      const languages = getLanguages().map((lang) => {
        let obj = {
          key: lang.id,
          label: lang.label,
          value: lang.id,
          icon: lang.flag,
        };
        return obj;
      });
      return languages;
    },
  },

  methods: {
    ...mapActions({
      changeCurrentLanguageCode: 'saryahLanding/landing/changeCurrentLanguageCode',
    }),
    // doChangeLanguage(language) {
    //   if(language != localStorage.getItem('language')) {
    //     I18nUtil.doChangeLanguage(language);
    //   }
    // },

    // doChangeLanguage(language) {
    //   i18n.locale = language;
    //   localStorage.setItem('language', language);

    //   const { lang } = this.$route.params;
    //   let route = '';
    //   if (lang && (lang === 'ar' || lang === 'en')) {
    //     route = `/${language}${this.$route.fullPath.substring(3)}`;
    //   } else {
    //     route = `/${language}${this.$route.fullPath}`;
    //   }
    //   if (language === 'ar') {
    //     // document.getElementsByTagName("html")[0].setAttribute("dir","rtl")
    //     // this.$q.lang.rtl = true
    //     // this.ar = true
    //     import(`quasar/lang/ar`).then((lang) => {
    //       // eslint-disable-next-line
    //       Quasar.lang.set(lang.default);
    //     });
    //   } else {
    //     // document.getElementsByTagName("html")[0].setAttribute("dir","ltr")
    //     // this.$q.lang.rtl = false
    //     // this.ar = false
    //     import(`quasar/lang/en-us`).then((lang) => {
    //       // eslint-disable-next-line
    //       Quasar.lang.set(lang.default);
    //     });
    //   }
    //   this.$router.push(route);
    //   // I18nUtil.doChangeLanguage(language);
    // },

    doChangeLanguage(language) {
      i18n.locale = language;
      localStorage.setItem('language', language);
      setLanguageCode(language)
      this.changeCurrentLanguageCode(language)

      const { lang } = this.$route.params;
      let route = '';
      if (lang && (lang === 'ar' || lang === 'en')) {
        route = `/${language}${this.$route.fullPath.substring(3)}`;
      } else {
        route = `/${language}${this.$route.fullPath}`;
      }

      if (language === 'ar') {
        import(`quasar/lang/ar`).then((lang) => {
          // eslint-disable-next-line
          Quasar.lang.set(lang.default);
        });
      } else {
        import(`quasar/lang/en-us`).then((lang) => {
          // eslint-disable-next-line
          Quasar.lang.set(lang.default);
        });
      }
      this.$router.push(route);
      // I18nUtil.doChangeLanguage(language);
    },
  },
};
</script>

<style>
.i18n-select {
  display: flex;
  align-items: center;
  justify-content: center;

  margin-left: auto !important;
  margin-right: auto;
}

.i18n-select img {
  margin-right: 8px;
  cursor: pointer;
  width: 10% !important;
}
</style>
